// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['hu_HU']  = {
  "name": "hu_HU",
  "day": {
    "abbrev": [
      "v",
      "h",
      "k",
      "sze",
      "cs",
      "p",
      "szo"
    ],
    "full": [
      "vasárnap",
      "hétfő",
      "kedd",
      "szerda",
      "csütörtök",
      "péntek",
      "szombat"
    ]
  },
  "month": {
    "abbrev": [
      "jan",
      "febr",
      "márc",
      "ápr",
      "máj",
      "jún",
      "júl",
      "aug",
      "szept",
      "okt",
      "nov",
      "dec"
    ],
    "full": [
      "január",
      "február",
      "március",
      "április",
      "május",
      "június",
      "július",
      "augusztus",
      "szeptember",
      "október",
      "november",
      "december"
    ]
  },
  "meridiem": [
    "",
    ""
  ],
  "date": "%Y-%m-%d",
  "time24": "%H.%M.%S",
  "dateTime": "%Y. %b. %e., %A, %H.%M.%S %Z",
  "time12": "%H.%M.%S",
  "full": "%Y. %b. %e., %A, %H.%M.%S %Z"
}

